<template>
  <div>
    <AppModal
      v-if="modalToggle"
      :message="message"
      :btnCase="btnCase"
      @modalConfirm="modalConfirm"
      @modalCancel="modalCancel"
      @modalCheck="modalCheck"
    />
    <div class="wthdr-wrap">
      <div class="app-wrap">
        <AppWthdrHeader
          @viewToggleEmit="viewToggleEmit"
        />
        <img src="@/assets/img/img_menu_bi_new.png" alt="img_menu_bi" class="main-img">
        <div class="wthdr-group">
          <div class="wthdr-content">
            <p class="wthdr-name"><span>{{ name }}</span> 님</p>
            <p class="wthdr-num"><span>연락처</span> {{ phone }}</p>
          </div>
          <ol class="wthdr-info">
            <li>온누리오더 서비스는 사용자가 원하는 경우 아래 [탈퇴하기] 버튼을 이용하여 언제든 탈퇴 가능합니다</li>
            <li>탈퇴 후 재가입도 언제든 가능합니다</li>
          </ol>
        </div>
        <button class="full-wthdr-btn" @click="openModal">
          탈퇴하기
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import service from '@/backend/modnpay_app_api'
import AppWthdrHeader from '@/components/Header/AppWthdrHeader.vue'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
/* eslint-disable eqeqeq */
export default {
  components: {
    AppWthdrHeader
  },
  props: {
    appDeviceId: Number,
    fcmFlag: Boolean
  },
  data () {
    return {
      name: '',
      phone: '',
      /** 모달 */
      modalToggle: false,
      message: '',
      btnCase: 2
    }
  },
  created () {
    this.myInfo()
  },
  methods: {
    openModal () {
      this.modalToggle = !this.modalToggle
      this.message = '온누리오더 서비스를 탈퇴하시겠습니까?<br/>재가입은 언제든 가능합니다'
      this.btnCase = 2
    },
    modalConfirm () {
      this.$router.replace({ name: 'AppOrderSelect' })
    },
    modalCancel () {
      this.modalToggle = false
    },
    modalCheck () {
      this.userWithdraw()
    },
    // 사용자 정보 조회
    async myInfo () {
      const req = {
        userCode: ''
      }
      const { data } = await service.myInfo(req)
      const code = data.resultCode

      if (code == 0) {
        this.name = data.name
        this.phone = data.phone
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    },
    // 탈퇴하기
    async userWithdraw () {
      const req = {
        userCode: ''
      }
      const { data } = await service.userWithdraw(req)
      const code = data.resultCode

      if (code == 0) {
        localStorage.removeItem('Authorization')
        localStorage.removeItem('encPasswd')
        localStorage.removeItem('appUserCode')
        this.message = '온누리오더 서비스에 탈퇴 처리되었습니다<br/>지금까지 모든오더 서비스를 이용해 주셔서 감사합니다'
        this.btnCase = 1
        this.appUpdateUserInfo('', '', data.orderAppUser)
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    }
  }
}
</script>

<style scoped>
.wthdr-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
}
@media (min-width: 500px) {
  .wthdr-wrap {
    height: 800px;
  }
}
</style>
